import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./moreOptionsPopOver.css";
import { colorBrandObject } from "../../../constants/brandings";

const MoreOptionsPopOver = ({ items, handleActionSelect }) => {
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelect = (data) => {
    handleActionSelect(data);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      {" "}
      <IconButton
        aria-label="more"
        id="more-option-button"
        aria-controls={open ? "more-options" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon sx={`${colorBrandObject?.sideBarSelectedOptionBackground}` }  />
      </IconButton>
      <Menu
        id="more-options"
        MenuListProps={{
          "aria-labelledby": "more-option-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            minWidth: "140px",
          },
        }}
      >
        {items?.map((item) => (
          <MenuItem
            key={item?.id}
            onClick={() => {
              item?.enable && handleSelect(item?.value);
            }}
            disableRipple={!item?.enable}
            className={`pop-over-items ${item?.enable ? "" : "disabled-item"}`}
          >
            {item?.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MoreOptionsPopOver;
